import { render } from "./ConsultationModal.vue?vue&type=template&id=1da44ec8"
import script from "./ConsultationModal.vue?vue&type=script&lang=js"
export * from "./ConsultationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__